
class FloatingButtons {
    constructor() {
        this.container = document.querySelector('.js-floating-buttons');
        this.sections = document.querySelectorAll('.js-hide-floating-buttons');
    }

    init() {
        if (this.container) {
            const _container = this.container;
            const observer = new IntersectionObserver(function (entries) {
                entries.forEach(entry => {
                    let rect = _container.getBoundingClientRect();
                    if (entry.isIntersecting) {
                        _container.classList.add('is-invisible');
                    } else if (entry.intersectionRatio <= 0.1) {
                        _container.classList.remove('is-invisible');
                    }
                });

            }, {
                threshold: [0.1]
            });

            this.sections.forEach(target => observer.observe(target));
        }
    }
}

export default new FloatingButtons();
